export type Language = 'it' | 'en' | 'es' | 'fr' | 'de' | 'pt' | 'ru' | 'nl' | 'cz' | 'hr';

export const translations = {
  it: {
    // Dashboard
    online: "ONLINE",
    offline: "OFFLINE",
    deliveries: "Consegne",
    earnings: "Guadagni",
    multiAppHub: "Multi-App Hub",
    closeWorkday: "Chiudi Giornata",
    confirmCloseWorkday: "Sei sicuro di voler chiudere la giornata lavorativa? Questo resetterà i contatori giornalieri e salverà un riepilogo nello storico.",
    workdayClosed: "Giornata lavorativa chiusa con successo!",
    errorClosingWorkday: "Errore durante la chiusura della giornata.",
    locationError: "Geolocalizzazione non supportata",
    confirmRejectOrder: "Sei sicuro di voler rifiutare questo ordine?",
    confirmAcceptOrder: "Accetti questo ordine?",
    enterValidAmount: "Inserisci un importo valido",
    errorUpdatingEarnings: "Errore durante l'aggiornamento dei guadagni",
    loadingProfile: "Caricamento Profilo...",
    loadingRiderApp: "caricamento app Rider",
    profileNotFound: "Profilo Non Trovato",
    profileNotFoundDesc: "Impossibile recuperare i dati del rider. Prova a effettuare nuovamente il login.",
    backToLogin: "Torna al Login",
    waitingApproval: "In Attesa di Approvazione",
    waitingApprovalDesc: "Il tuo account è stato creato ma deve essere approvato dall'amministratore prima di poter iniziare.",
    riderId: "ID Rider",
    logout: "Logout",
    manageAllPlatforms: "Gestisci tutte le piattaforme",
    recordExternalEarning: "Registra Guadagno Esterno",
    totalTodayExternal: "Totale Oggi (Esterno)",
    noExternalOrdersToday: "Nessun ordine esterno registrato oggi.",
    note: "Nota",
    multiAppNote: "Per limitazioni tecniche delle piattaforme (Just Eat, Glovo, ecc.), non è possibile importare automaticamente gli ordini. Usa questo Hub per passare velocemente da un'app all'altra e tenere traccia dei tuoi guadagni totali in un unico posto.",
    locationAccessDenied: "⚠️ Accesso alla posizione negato.\n\nPer lavorare come Rider devi consentire l'accesso alla posizione 'Sempre' o 'Mentre usi l'app'.\n\nVai in Impostazioni > Privacy > Localizzazione.",
    locationUnavailable: "⚠️ Posizione non disponibile. Assicurati che il GPS sia attivo.",
    locationTimeout: "⚠️ Timeout. Spostati all'aperto e riprova.",
    callError: "Errore durante la chiamata: ",
    namePhoneRequired: "Nome e telefono sono obbligatori",
    profileUpdated: "Profilo aggiornato con successo!",
    profileUpdateError: "Errore durante l'aggiornamento del profilo",
    mustBeApprovedOnline: "Devi essere approvato per andare online.",
    mustBeApprovedAccept: "Devi essere approvato per accettare ordini.",
    locationNotAvailableOnline: "Posizione non disponibile. Assicurati di essere online.",
    missingDestCoords: "Coordinate destinazione mancanti per {address}. Impossibile avviare navigazione.",
    videoCallComingSoon: "Funzionalità videochiamata in arrivo!",
    walletToday: "Portafoglio Oggi",
    
    // Navigator
    activeNavigation: "Navigazione Attiva",
    previewRoute: "Anteprima Percorso",
    startNavigation: "AVVIA NAVIGAZIONE",
    nextTurn: "Prossima Svolta",
    destination: "Destinazione",
    youAreHere: "Tu sei qui",
    missingCoordinates: "Coordinate Mancanti",
    gpsSignalLost: "Segnale GPS Assente",
    addressNotFound: "Indirizzo Non Trovato",
    searchingLocation: "Ricerca Posizione...",
    searchingLocationDesc: "Stiamo cercando le coordinate dell'indirizzo.",
    cantDetectLocation: "Impossibile rilevare la tua posizione.",
    invalidDestination: "L'indirizzo di destinazione non ha coordinate valide.",
    cantDetectLocationDesc: "Impossibile rilevare la tua posizione. Assicurati di aver attivato il GPS.",
    addressNotFoundDesc: "Non siamo riusciti a trovare le coordinate per:",
    close: "Chiudi",
    
    // Instructions
    head: "Procedi verso",
    destinationReached: "Sei arrivato a destinazione",
    
    // Route Planner
    routePlanner: "Pianificatore Percorso",
    dragToReorder: "Usa le frecce per riordinare le fermate",
    startRoute: "Avvia Percorso",
    noActiveOrders: "Nessun ordine attivo da pianificare",
    pickup: "Ritiro",
    dropoff: "Consegna",
    
    // Admin Dashboard
    admin_orders_history: "Storico Ordini",
    admin_orders_history_desc: "Gestione archivio",
    admin_delivery: "Consegne",
    admin_shipping: "Spedizioni",
    admin_delivery_desc: "Zone e costi",
    admin_shipping_desc: "Costi Spedizione",
    admin_rider_map: "Mappa Rider",
    admin_rider_map_desc: "Gestione flotta e tracking",
    admin_products: "Prodotti",
    admin_products_desc: "Gestisci articoli",
    admin_ingredients: "Ingredienti",
    admin_variants: "Varianti",
    admin_ingredients_desc: "Extra e aggiunte",
    admin_variants_desc: "Taglie, Colori",
    admin_menu_structure: "Struttura Menu",
    admin_menu_structure_desc: "Menu e Categorie",
    admin_opening_hours: "Orari & Chiusure",
    admin_opening_hours_desc: "Giorni, fasce e ferie",
    admin_graphics: "Grafica & Colori",
    admin_graphics_desc: "Personalizza aspetto",
    admin_customers: "Clienti",
    admin_customers_desc: "Lista e Contatti",
    admin_cameras: "Telecamere",
    admin_cameras_desc: "Configura IP Cam",
    admin_fiscal_printer: "Registratore Telematico",
    admin_fiscal_printer_desc: "Integrazione Cassa",
    admin_advanced_settings: "Configurazioni Avanzate",
    admin_settings_general: "Generale & Pagamenti",
    admin_settings_general_desc: "Info attività, Nexi, Satispay, PayPal, Suoni",
    admin_settings_marketing: "Marketing & Loyalty",
    admin_settings_marketing_desc: "Programma Fedeltà, Coupon, Opzioni Servizio",
    admin_settings_system: "Sistema & Dati",
    admin_settings_system_desc: "Backup, Sicurezza, Admin",
    
    // Marketing & Loyalty
    discount_auto: "Sconto Automatico Cassa",
    discount_auto_desc: "Applica uno sconto percentuale automatico al totale del carrello per specifiche modalità d'ordine. Questo sconto si applica direttamente nel carrello senza bisogno di codici.",
    discount_delivery_pct: "Sconto per Domicilio (%)",
    discount_takeaway_pct: "Sconto per Asporto (%)",
    discount_dinein_pct: "Sconto per Tavolo (%)",
    confirm_save: "Conferma (Ricorda di Salvare)",

    // Header Admin
    admin_header_intercom: "Intercom",
    admin_header_intercom_title: "Chiama Locale (Video)",
    admin_header_mute: "Muto",
    admin_header_notif: "Suono",
    admin_header_mute_title: "Disattiva chiamate Intercom su questo dispositivo",
    admin_header_unmute_title: "Riattiva chiamate Intercom",
    admin_header_cam: "Cam",
    admin_header_cam_title: "Monitor Telecamere",
    admin_header_rider: "Rider",
    admin_header_rider_title: "Monitor Rider",
    admin_header_app: "App",
    admin_header_app_title: "Vedi App Cliente",
    admin_header_orders: "Ordini",
    admin_header_orders_title: "Ordini in corso",
    admin_header_exit: "Esci",
    admin_header_exit_title: "Esci dall'Admin",

    // Tooltips
    iot_browser_mode_tooltip: "Questa è per soluzioni POS 'Android Embedded' come i terminali Sunmi o tablet classici. Quando un ordine viene generato, il browser inietta istantaneamente un template a scorrimento in una finestra fantasma forzandone un'auto-stampa termica in ricezione.",
    iot_epos_mode_tooltip: "Permette di connettersi in automatico alle tue stampanti Wi-Fi saltando le finestre di sistema. Invia input diretti tramite l'URL IP Locale della stampante (es. 192.168.1.100), se supporta il servizio FPMate/ePOS (come la serie Epson TM).",
    iot_webhook_mode_tooltip: "Ideale per l'automazione Cloud. Il sistema, ogni volta che ricevi un ordine, effettuerà una richiesta Webhook (POST HTTP) verso l'URL inserito (es. Make, Zapier o il tuo server) inviando l'intero scontrino in formato JSON.",
    analytics_timeframe_tooltip: "Il filtro modificherà l'orizzonte temporale su cui l'intelligenza analitica basa le sue previsioni e conteggi (ultimi 7, 30 o 90 giorni).",
    analytics_today_prediction_tooltip: "Questo è il calcolo probabilistico degli ordini previsti per l'intera giornata di oggi. Viene effettuato calcolando la media pesata del numero di ordini che solitamente ricevi per l'attuale giorno della settimana.",
    analytics_total_orders_tooltip: "Somma degli scontrini generati nell'arco di tempo selezionato. Questa cifra fa da serbatoio storico per l'analisi predittiva.",
    analytics_revenue_tooltip: "Fatturato netto totale generato tramite l'app nel periodo temporale preso in analisi (esclusi eventuali rimborsi manuali o scarti).",
    analytics_weekly_chart_tooltip: "Grafico a barre sull'afflusso cumulativo spalmato sui giorni della settimana. Molto utile per identificare a colpo d'occhio i giorni di punta per assumere extra e i giorni morti dove lanciare sconti Flash.",
    analytics_peak_hours_tooltip: "Grafico della distribuzione oraria. Mostra in quale ora esatta i clienti battono la pre-comanda. Fondamentale per la cucina per determinare a che ora far partire i preriscaldamenti e le infornate strategiche."
  },
  en: {
    // Dashboard
    online: "ONLINE",
    offline: "OFFLINE",
    deliveries: "Deliveries",
    earnings: "Earnings",
    multiAppHub: "Multi-App Hub",
    closeWorkday: "End Shift",
    confirmCloseWorkday: "Are you sure you want to end your shift? This will reset daily counters and save a summary to history.",
    workdayClosed: "Shift ended successfully!",
    errorClosingWorkday: "Error ending shift.",
    locationError: "Geolocation not supported",
    confirmRejectOrder: "Are you sure you want to reject this order?",
    confirmAcceptOrder: "Do you accept this order?",
    enterValidAmount: "Please enter a valid amount",
    errorUpdatingEarnings: "Error updating earnings",
    loadingProfile: "Loading Profile...",
    loadingRiderApp: "loading Rider app",
    profileNotFound: "Profile Not Found",
    profileNotFoundDesc: "Unable to retrieve rider data. Please try logging in again.",
    backToLogin: "Back to Login",
    waitingApproval: "Waiting for Approval",
    waitingApprovalDesc: "Your account has been created but needs to be approved by an administrator before you can start.",
    riderId: "Rider ID",
    logout: "Logout",
    manageAllPlatforms: "Manage all platforms",
    recordExternalEarning: "Record External Earning",
    totalTodayExternal: "Total Today (External)",
    noExternalOrdersToday: "No external orders recorded today.",
    note: "Note",
    multiAppNote: "Due to technical limitations of platforms (Just Eat, Glovo, etc.), orders cannot be imported automatically. Use this Hub to quickly switch between apps and track your total earnings in one place.",
    locationAccessDenied: "⚠️ Location access denied.\n\nTo work as a Rider you must allow location access 'Always' or 'While using the app'.\n\nGo to Settings > Privacy > Location.",
    locationUnavailable: "⚠️ Location unavailable. Please ensure GPS is enabled.",
    locationTimeout: "⚠️ Timeout. Move outdoors and try again.",
    callError: "Error during call: ",
    namePhoneRequired: "Name and phone are required",
    profileUpdated: "Profile updated successfully!",
    profileUpdateError: "Error updating profile",
    mustBeApprovedOnline: "You must be approved to go online.",
    mustBeApprovedAccept: "You must be approved to accept orders.",
    locationNotAvailableOnline: "Location not available. Make sure you are online.",
    missingDestCoords: "Missing destination coordinates for {address}. Cannot start navigation.",
    videoCallComingSoon: "Video call feature coming soon!",
    walletToday: "Wallet Today",

    // Navigator
    activeNavigation: "Active Navigation",
    previewRoute: "Route Preview",
    startNavigation: "START NAVIGATION",
    nextTurn: "Next Turn",
    destination: "Destination",
    youAreHere: "You are here",
    missingCoordinates: "Missing Coordinates",
    gpsSignalLost: "GPS Signal Lost",
    addressNotFound: "Address Not Found",
    searchingLocation: "Searching Location...",
    searchingLocationDesc: "We are looking for the address coordinates.",
    cantDetectLocation: "Cannot detect your location.",
    invalidDestination: "Destination address has invalid coordinates.",
    cantDetectLocationDesc: "Cannot detect your location. Please ensure GPS is enabled.",
    addressNotFoundDesc: "We could not find coordinates for:",
    close: "Close",

    // Instructions
    head: "Head towards",
    destinationReached: "You have arrived at your destination",

    // Route Planner
    routePlanner: "Route Planner",
    dragToReorder: "Use arrows to reorder stops",
    startRoute: "Start Route",
    noActiveOrders: "No active orders to plan",
    pickup: "Pickup",
    dropoff: "Dropoff",
    
    // Admin Dashboard
    admin_orders_history: "Order History",
    admin_orders_history_desc: "Archive management",
    admin_delivery: "Deliveries",
    admin_shipping: "Shipping",
    admin_delivery_desc: "Zones and costs",
    admin_shipping_desc: "Shipping Costs",
    admin_rider_map: "Rider Map",
    admin_rider_map_desc: "Fleet management and tracking",
    admin_products: "Products",
    admin_products_desc: "Manage items",
    admin_ingredients: "Ingredients",
    admin_variants: "Variants",
    admin_ingredients_desc: "Extras and additions",
    admin_variants_desc: "Sizes, Colors",
    admin_menu_structure: "Menu Structure",
    admin_menu_structure_desc: "Menus and Categories",
    admin_opening_hours: "Opening Hours",
    admin_opening_hours_desc: "Days, slots and holidays",
    admin_graphics: "Graphics & Colors",
    admin_graphics_desc: "Customize appearance",
    admin_customers: "Customers",
    admin_customers_desc: "List and Contacts",
    admin_cameras: "Cameras",
    admin_cameras_desc: "Configure IP Cams",
    admin_fiscal_printer: "Fiscal Printer",
    admin_fiscal_printer_desc: "Cash Register Integration",
    admin_advanced_settings: "Advanced Configurations",
    admin_settings_general: "General & Payments",
    admin_settings_general_desc: "Business info, Nexi, Satispay, PayPal, Sounds",
    admin_settings_marketing: "Marketing & Loyalty",
    admin_settings_marketing_desc: "Loyalty Program, Coupons, Service Options",
    admin_settings_system: "System & Data",
    admin_settings_system_desc: "Backup, Security, Admin",

    // Marketing & Loyalty
    discount_auto: "Automatic Checkout Discount",
    discount_auto_desc: "Applies an automatic percentage discount to the cart total for specific order modes. This discount applies directly in the cart without needing codes.",
    discount_delivery_pct: "Delivery Discount (%)",
    discount_takeaway_pct: "Takeaway Discount (%)",
    discount_dinein_pct: "Dine-in Discount (%)",
    confirm_save: "Confirm (Remember to Save)",

    // Header Admin
    admin_header_intercom: "Intercom",
    admin_header_intercom_title: "Call Venue (Video)",
    admin_header_mute: "Mute",
    admin_header_notif: "Sound",
    admin_header_mute_title: "Mute Intercom calls on this device",
    admin_header_unmute_title: "Unmute Intercom calls",
    admin_header_cam: "Cam",
    admin_header_cam_title: "Camera Monitor",
    admin_header_rider: "Rider",
    admin_header_rider_title: "Rider Monitor",
    admin_header_app: "App",
    admin_header_app_title: "View Customer App",
    admin_header_orders: "Orders",
    admin_header_orders_title: "Current Orders",
    admin_header_exit: "Exit",
    admin_header_exit_title: "Exit Admin",

    // Tooltips
    iot_browser_mode_tooltip: "This is for 'Android Embedded' POS solutions like Sunmi terminals or classic tablets. When an order is generated, the browser instantly injects a scrolling template into a ghost window, forcing a thermal auto-print on receipt.",
    iot_epos_mode_tooltip: "Allows automatic connection to your Wi-Fi printers, bypassing system windows. Sends direct input via the printer's Local IP URL (e.g. 192.168.1.100), if it supports the FPMate/ePOS service (like the Epson TM series).",
    iot_webhook_mode_tooltip: "Ideal for Cloud automation. The system, every time you receive an order, will make a Webhook request (HTTP POST) to the inserted URL (e.g. Make, Zapier or your server) sending the entire receipt in JSON format.",
    analytics_timeframe_tooltip: "The filter will modify the time horizon on which the analytical intelligence bases its predictions and counts (last 7, 30 or 90 days).",
    analytics_today_prediction_tooltip: "This is the probabilistic calculation of the predicted orders for the entire day today. It is performed by calculating the weighted average of the number of orders you usually receive for the current day of the week.",
    analytics_total_orders_tooltip: "Sum of receipts generated in the selected time frame. This figure acts as a historical reservoir for predictive analysis.",
    analytics_revenue_tooltip: "Total net revenue generated through the app in the analyzed time period (excluding any manual refunds or discards).",
    analytics_weekly_chart_tooltip: "Bar chart on the cumulative influx spread over the days of the week. Very useful for identifying at a glance the peak days to hire extras and the dead days to launch Flash discounts.",
    analytics_peak_hours_tooltip: "Hourly distribution graph. Shows at what exact time customers place the pre-order. Fundamental for the kitchen to determine what time to start preheating and strategic baking."
  },
  es: {
    // Dashboard
    online: "EN LÍNEA",
    offline: "DESCONECTADO",
    deliveries: "Entregas",
    earnings: "Ganancias",
    multiAppHub: "Centro Multi-App",
    closeWorkday: "Cerrar Turno",
    confirmCloseWorkday: "¿Seguro que quieres cerrar el turno? Esto restablecerá los contadores diarios y guardará un resumen en el historial.",
    workdayClosed: "¡Turno cerrado con éxito!",
    errorClosingWorkday: "Error al cerrar el turno.",
    locationError: "Geolocalización no soportada",
    confirmRejectOrder: "¿Estás seguro de que quieres rechazar este pedido?",
    confirmAcceptOrder: "¿Aceptas este pedido?",
    enterValidAmount: "Por favor ingrese un monto válido",
    errorUpdatingEarnings: "Error al actualizar las ganancias",
    loadingProfile: "Cargando Perfil...",
    loadingRiderApp: "cargando app Rider",
    profileNotFound: "Perfil No Encontrado",
    profileNotFoundDesc: "No se pudieron recuperar los datos del repartidor. Intente iniciar sesión nuevamente.",
    backToLogin: "Volver al Inicio de Sesión",
    waitingApproval: "Esperando Aprobación",
    waitingApprovalDesc: "Su cuenta ha sido creada pero necesita ser aprobada por un administrador antes de poder comenzar.",
    riderId: "ID de Repartidor",
    logout: "Cerrar Sesión",
    manageAllPlatforms: "Gestionar todas las plataformas",
    recordExternalEarning: "Registrar Ganancia Externa",
    totalTodayExternal: "Total Hoy (Externo)",
    noExternalOrdersToday: "No hay pedidos externos registrados hoy.",
    note: "Nota",
    multiAppNote: "Debido a limitaciones técnicas de las plataformas (Just Eat, Glovo, etc.), los pedidos no se pueden importar automáticamente. Use este Centro para cambiar rápidamente entre aplicaciones y rastrear sus ganancias totales en un solo lugar.",
    locationAccessDenied: "⚠️ Acceso a la ubicación denegado.\n\nPara trabajar como Repartidor debes permitir el acceso a la ubicación 'Siempre' o 'Al usar la aplicación'.\n\nVe a Configuración > Privacidad > Ubicación.",
    locationUnavailable: "⚠️ Ubicación no disponible. Asegúrese de que el GPS esté activado.",
    locationTimeout: "⚠️ Tiempo de espera agotado. Muévase al aire libre e intente nuevamente.",
    callError: "Error durante la llamada: ",
    namePhoneRequired: "Nombre y teléfono son obligatorios",
    profileUpdated: "¡Perfil actualizado con éxito!",
    profileUpdateError: "Error al actualizar el perfil",
    mustBeApprovedOnline: "Debes ser aprobado para conectarte.",
    mustBeApprovedAccept: "Debes ser aprobado para aceptar pedidos.",
    locationNotAvailableOnline: "Ubicación no disponible. Asegúrate de estar conectado.",
    missingDestCoords: "Faltan coordenadas de destino para {address}. No se puede iniciar la navegación.",
    videoCallComingSoon: "¡Función de videollamada próximamente!",
    walletToday: "Billetera Hoy",

    // Navigator
    activeNavigation: "Navegación Activa",
    previewRoute: "Vista Previa de Ruta",
    startNavigation: "INICIAR NAVEGACIÓN",
    nextTurn: "Próximo Giro",
    destination: "Destino",
    youAreHere: "Estás aquí",
    missingCoordinates: "Coordenadas Faltantes",
    gpsSignalLost: "Señal GPS Perdida",
    addressNotFound: "Dirección No Encontrada",
    searchingLocation: "Buscando Ubicación...",
    searchingLocationDesc: "Estamos buscando las coordenadas de la dirección.",
    cantDetectLocation: "No se puede detectar tu ubicación.",
    invalidDestination: "La dirección de destino tiene coordenadas inválidas.",
    cantDetectLocationDesc: "No se puede detectar tu ubicación. Asegúrate de tener el GPS activado.",
    addressNotFoundDesc: "No pudimos encontrar coordenadas para:",
    close: "Cerrar",

    // Instructions
    head: "Dirígete hacia",
    destinationReached: "Has llegado a tu destino",

    // Route Planner
    routePlanner: "Planificador de Ruta",
    dragToReorder: "Usa las flechas para reordenar las paradas",
    startRoute: "Iniciar Ruta",
    noActiveOrders: "No hay pedidos activos para planificar",
    pickup: "Recogida",
    dropoff: "Entrega",
    
    // Admin Dashboard
    admin_orders_history: "Historial de Pedidos",
    admin_orders_history_desc: "Gestión de archivo",
    admin_delivery: "Entregas",
    admin_shipping: "Envíos",
    admin_delivery_desc: "Zonas y costos",
    admin_shipping_desc: "Costos de Envío",
    admin_rider_map: "Mapa de Repartidores",
    admin_rider_map_desc: "Gestión de flota y seguimiento",
    admin_products: "Productos",
    admin_products_desc: "Gestionar artículos",
    admin_ingredients: "Ingredientes",
    admin_variants: "Variantes",
    admin_ingredients_desc: "Extras y adiciones",
    admin_variants_desc: "Tallas, Colores",
    admin_menu_structure: "Estructura del Menú",
    admin_menu_structure_desc: "Menús y Categorías",
    admin_opening_hours: "Horarios",
    admin_opening_hours_desc: "Días, franjas y vacaciones",
    admin_graphics: "Gráficos y Colores",
    admin_graphics_desc: "Personalizar apariencia",
    admin_customers: "Clientes",
    admin_customers_desc: "Lista y Contactos",
    admin_cameras: "Cámaras",
    admin_cameras_desc: "Configurar Cámaras IP",
    admin_fiscal_printer: "Impresora Fiscal",
    admin_fiscal_printer_desc: "Integración de Caja",
    admin_advanced_settings: "Configuraciones Avanzadas",
    admin_settings_general: "General y Pagos",
    admin_settings_general_desc: "Info negocio, Nexi, Satispay, PayPal, Sonidos",
    admin_settings_marketing: "Marketing y Lealtad",
    admin_settings_marketing_desc: "Programa de Lealtad, Cupones, Opciones de Servicio",
    admin_settings_system: "Sistema y Datos",
    admin_settings_system_desc: "Copia de seguridad, Seguridad, Admin",

    // Marketing & Loyalty
    discount_auto: "Descuento automático en caja",
    discount_auto_desc: "Aplica un porcentaje de descuento automático al total del carrito para modalidades de pedido específicas. Este descuento se aplica directamente en el carrito sin necesidad de códigos.",
    discount_delivery_pct: "Descuento por Entrega (%)",
    discount_takeaway_pct: "Descuento por Recogida (%)",
    discount_dinein_pct: "Descuento por Mesa (%)",
    confirm_save: "Confirmar (Recuerda Guardar)",

    // Header Admin
    admin_header_intercom: "Intercom",
    admin_header_intercom_title: "Llamar Local (Video)",
    admin_header_mute: "Silenciar",
    admin_header_notif: "Sonido",
    admin_header_mute_title: "Silenciar llamadas de Intercom en este dispositivo",
    admin_header_unmute_title: "Activar llamadas de Intercom",
    admin_header_cam: "Cámara",
    admin_header_cam_title: "Monitor de Cámaras",
    admin_header_rider: "Rider",
    admin_header_rider_title: "Monitor de Rider",
    admin_header_app: "App",
    admin_header_app_title: "Ver App Cliente",
    admin_header_orders: "Pedidos",
    admin_header_orders_title: "Pedidos Actuales",
    admin_header_exit: "Salir",
    admin_header_exit_title: "Salir de Admin",

    // Tooltips
    iot_browser_mode_tooltip: "Esto es para soluciones POS 'Android Embedded' como terminales Sunmi o tabletas clásicas. Cuando se genera un pedido, el navegador inyecta instantáneamente una plantilla desplazable en una ventana fantasma, obligando a una impresión térmica al recibirlo.",
    iot_epos_mode_tooltip: "Permite la conexión automática a tus impresoras Wi-Fi, omitiendo las ventanas del sistema. Envía entrada directa a través de la URL de IP local de la impresora (ej. 192.168.1.100), si admite el servicio FPMate/ePOS (como la serie Epson TM).",
    iot_webhook_mode_tooltip: "Ideal para la automatización de la nube. El sistema, cada vez que reciba un pedido, hará una solicitud de Webhook (POST HTTP) a la URL insertada (ej. Make, Zapier o su servidor) enviando el recibo completo en formato JSON.",
    analytics_timeframe_tooltip: "El filtro modificará el horizonte temporal sobre el cual la inteligencia analítica basa sus predicciones y recuentos (últimos 7, 30 o 90 días).",
    analytics_today_prediction_tooltip: "Este es el cálculo probabilístico de los pedidos previstos para todo el día de hoy. Se realiza calculando el promedio ponderado de la cantidad de pedidos que recibe habitualmente en el día de la semana en curso.",
    analytics_total_orders_tooltip: "Suma de recibos generados en el marco temporal seleccionado. Cifra que sirve como reserva histórica para el análisis predictivo.",
    analytics_revenue_tooltip: "Ingresos netos totales generados a través de la aplicación en el período de tiempo analizado (excluyendo cualquier reembolso o descarte manual).",
    analytics_weekly_chart_tooltip: "Gráfico de barras sobre la afluencia acumulativa distribuida a lo largo de los días de la semana. Es muy útil para identificar de un vistazo los días pico para contratar extras y los días muertos para lanzar descuentos rápidos.",
    analytics_peak_hours_tooltip: "Gráfico de distribución horaria. Muestra a qué hora exacta los clientes realizan el pedido anticipado. Es fundamental para que la cocina determine a qué hora empezar a precalentar y a hornear de forma estratégica."
  },
  fr: {
    // Dashboard
    online: "EN LIGNE",
    offline: "HORS LIGNE",
    deliveries: "Livraisons",
    earnings: "Gains",
    multiAppHub: "Hub Multi-App",
    closeWorkday: "Fin de Service",
    confirmCloseWorkday: "Êtes-vous sûr de vouloir terminer votre service ? Cela réinitialisera les compteurs quotidiens et enregistrera un résumé dans l'historique.",
    workdayClosed: "Service terminé avec succès !",
    errorClosingWorkday: "Erreur lors de la fin de service.",
    locationError: "Géolocalisation non prise en charge",
    confirmRejectOrder: "Êtes-vous sûr de vouloir refuser cette commande ?",
    confirmAcceptOrder: "Acceptez-vous cette commande ?",
    enterValidAmount: "Veuillez entrer un montant valide",
    errorUpdatingEarnings: "Erreur lors de la mise à jour des gains",
    loadingProfile: "Chargement du Profil...",
    loadingRiderApp: "chargement app Rider",
    profileNotFound: "Profil Non Trouvé",
    profileNotFoundDesc: "Impossible de récupérer les données du livreur. Veuillez essayer de vous reconnecter.",
    backToLogin: "Retour à la Connexion",
    waitingApproval: "En Attente d'Approbation",
    waitingApprovalDesc: "Votre compte a été créé mais doit être approuvé par un administrateur avant de pouvoir commencer.",
    riderId: "ID Livreur",
    logout: "Déconnexion",
    manageAllPlatforms: "Gérer toutes les plateformes",
    recordExternalEarning: "Enregistrer Gain Externe",
    totalTodayExternal: "Total Aujourd'hui (Externe)",
    noExternalOrdersToday: "Aucune commande externe enregistrée aujourd'hui.",
    note: "Note",
    multiAppNote: "En raison de limitations techniques des plateformes (Just Eat, Glovo, etc.), les commandes ne peuvent pas être importées automatiquement. Utilisez ce Hub pour basculer rapidement entre les applications et suivre vos gains totaux en un seul endroit.",
    locationAccessDenied: "⚠️ Accès à la localisation refusé.\n\nPour travailler comme Livreur, vous devez autoriser l'accès à la localisation 'Toujours' ou 'Lorsque vous utilisez l'application'.\n\nAllez dans Paramètres > Confidentialité > Localisation.",
    locationUnavailable: "⚠️ Localisation indisponible. Veuillez vous assurer que le GPS est activé.",
    locationTimeout: "⚠️ Délai d'attente dépassé. Déplacez-vous à l'extérieur et réessayez.",
    callError: "Erreur pendant l'appel : ",
    namePhoneRequired: "Le nom et le téléphone sont obligatoires",
    profileUpdated: "Profil mis à jour avec succès !",
    profileUpdateError: "Erreur lors de la mise à jour du profil",
    mustBeApprovedOnline: "Vous devez être approuvé pour vous connecter.",
    mustBeApprovedAccept: "Vous devez être approuvé pour accepter des commandes.",
    locationNotAvailableOnline: "Position indisponible. Assurez-vous d'être en ligne.",
    missingDestCoords: "Coordonnées de destination manquantes pour {address}. Impossible de démarrer la navigation.",
    videoCallComingSoon: "Fonctionnalité d'appel vidéo à venir !",
    walletToday: "Portefeuille Aujourd'hui",

    // Navigator
    activeNavigation: "Navigation Active",
    previewRoute: "Aperçu de l'Itinéraire",
    startNavigation: "DÉMARRER LA NAVIGATION",
    nextTurn: "Prochain Tournant",
    destination: "Destination",
    youAreHere: "Vous êtes ici",
    missingCoordinates: "Coordonnées Manquantes",
    gpsSignalLost: "Signal GPS Perdu",
    addressNotFound: "Adresse Non Trouvée",
    searchingLocation: "Recherche de l'Emplacement...",
    searchingLocationDesc: "Nous recherchons les coordonnées de l'adresse.",
    cantDetectLocation: "Impossible de détecter votre position.",
    invalidDestination: "L'adresse de destination a des coordonnées invalides.",
    cantDetectLocationDesc: "Impossible de détecter votre position. Veuillez vous assurer que le GPS est activé.",
    addressNotFoundDesc: "Nous n'avons pas pu trouver de coordonnées pour :",
    close: "Fermer",

    // Instructions
    head: "Dirigez-vous vers",
    destinationReached: "Vous êtes arrivé à destination",

    // Route Planner
    routePlanner: "Planificateur d'Itinéraire",
    dragToReorder: "Utilisez les flèches pour réorganiser les arrêts",
    startRoute: "Démarrer l'Itinéraire",
    noActiveOrders: "Aucune commande active à planifier",
    pickup: "Ramassage",
    dropoff: "Livraison",
    
    // Admin Dashboard
    admin_orders_history: "Historique des Commandes",
    admin_orders_history_desc: "Gestion des archives",
    admin_delivery: "Livraisons",
    admin_shipping: "Expéditions",
    admin_delivery_desc: "Zones et coûts",
    admin_shipping_desc: "Frais d'expédition",
    admin_rider_map: "Carte des Livreurs",
    admin_rider_map_desc: "Gestion de flotte et suivi",
    admin_products: "Produits",
    admin_products_desc: "Gérer les articles",
    admin_ingredients: "Ingrédients",
    admin_variants: "Variantes",
    admin_ingredients_desc: "Extras et ajouts",
    admin_variants_desc: "Tailles, Couleurs",
    admin_menu_structure: "Structure du Menu",
    admin_menu_structure_desc: "Menus et Catégories",
    admin_opening_hours: "Horaires",
    admin_opening_hours_desc: "Jours, créneaux et congés",
    admin_graphics: "Graphiques et Couleurs",
    admin_graphics_desc: "Personnaliser l'apparence",
    admin_customers: "Clients",
    admin_customers_desc: "Liste et Contacts",
    admin_cameras: "Caméras",
    admin_cameras_desc: "Configurer les Caméras IP",
    admin_fiscal_printer: "Imprimante Fiscale",
    admin_fiscal_printer_desc: "Intégration Caisse",
    admin_advanced_settings: "Configurations Avancées",
    admin_settings_general: "Général et Paiements",
    admin_settings_general_desc: "Info entreprise, Nexi, Satispay, PayPal, Sons",
    admin_settings_marketing: "Marketing et Fidélité",
    admin_settings_marketing_desc: "Programme de Fidélité, Coupons, Options de Service",
    admin_settings_system: "Système et Données",
    admin_settings_system_desc: "Sauvegarde, Sécurité, Admin",

    // Marketing & Loyalty
    discount_auto: "Remise automatique en caisse",
    discount_auto_desc: "Applique une remise en pourcentage automatique au total du panier pour les modes de commande spécifiques. S'applique directement sans codes.",
    discount_delivery_pct: "Remise Livraison (%)",
    discount_takeaway_pct: "Remise À Emporter (%)",
    discount_dinein_pct: "Remise Sur Place (%)",
    confirm_save: "Confirmer (N'oubliez pas d'enregistrer)",

    // Header Admin
    admin_header_intercom: "Intercom",
    admin_header_intercom_title: "Appeler Local (Vidéo)",
    admin_header_mute: "Muet",
    admin_header_notif: "Son",
    admin_header_mute_title: "Couper les sonneries Intercom sur cet appareil",
    admin_header_unmute_title: "Réactiver les sonneries Intercom",
    admin_header_cam: "Cam",
    admin_header_cam_title: "Moniteur Caméras",
    admin_header_rider: "Rider",
    admin_header_rider_title: "Moniteur Rider",
    admin_header_app: "App",
    admin_header_app_title: "Voir l'App Client",
    admin_header_orders: "Commandes",
    admin_header_orders_title: "Commandes en Cours",
    admin_header_exit: "Quitter",
    admin_header_exit_title: "Quitter l'Admin",

    // Tooltips
    iot_browser_mode_tooltip: "Ceci est pour les solutions POS 'Android Embedded' comme les terminaux Sunmi ou les tablettes classiques. Lorsqu'une commande est générée, le navigateur injecte instantanément un modèle défilant dans une fenêtre fantôme, forçant une impression thermique automatique à la réception.",
    iot_epos_mode_tooltip: "Permet la connexion automatique à vos imprimantes Wi-Fi en contournant les fenêtres système. Envoie l'entrée directe via l'URL IP locale de l'imprimante (ex. 192.168.1.100), si elle supporte le service FPMate/ePOS (comme la série Epson TM).",
    iot_webhook_mode_tooltip: "Idéal pour l'automatisation Cloud. Le système, chaque fois que vous recevez une commande, effectuera une requête Webhook (POST HTTP) vers l'URL insérée (ex. Make, Zapier ou votre serveur) envoyant le reçu complet au format JSON.",
    analytics_timeframe_tooltip: "Le filtre modifiera l'horizon temporel sur lequel l'intelligence analytique base ses prévisions et décomptes (les 7, 30 ou 90 derniers jours).",
    analytics_today_prediction_tooltip: "Ceci est le calcul probabiliste des commandes prévues pour toute la journée d'aujourd'hui. Il est effectué en calculant la moyenne pondérée du nombre de commandes que vous recevez habituellement pour le jour de la semaine en cours.",
    analytics_total_orders_tooltip: "Somme des reçus générés dans la période de temps sélectionnée. Ce chiffre sert de réservoir historique pour l'analyse prédictive.",
    analytics_revenue_tooltip: "Chiffre d'affaires net total généré via l'application sur la période analysée (hors remboursements ou rejets manuels).",
    analytics_weekly_chart_tooltip: "Graphique à barres sur l'afflux cumulé réparti sur les jours de la semaine. Très utile pour identifier d'un coup d'œil les jours de pointe pour embaucher des extras et les jours creux pour lancer des remises Flash.",
    analytics_peak_hours_tooltip: "Graphique de la distribution horaire. Montre à quelle heure exacte les clients passent la précommande. Fondamental pour que la cuisine détermine à quelle heure commencer le préchauffage et les cuissons stratégiques."
  },
  de: {
    // Dashboard
    online: "ONLINE",
    offline: "OFFLINE",
    deliveries: "Lieferungen",
    earnings: "Einnahmen",
    multiAppHub: "Multi-App Hub",
    closeWorkday: "Schicht Beenden",
    confirmCloseWorkday: "Sind Sie sicher, dass Sie Ihre Schicht beenden möchten? Dies setzt die Tageszähler zurück und speichert eine Zusammenfassung im Verlauf.",
    workdayClosed: "Schicht erfolgreich beendet!",
    errorClosingWorkday: "Fehler beim Beenden der Schicht.",
    locationError: "Geolokalisierung nicht unterstützt",
    confirmRejectOrder: "Sind Sie sicher, dass Sie diese Bestellung ablehnen möchten?",
    confirmAcceptOrder: "Akzeptieren Sie diese Bestellung?",
    enterValidAmount: "Bitte geben Sie einen gültigen Betrag ein",
    errorUpdatingEarnings: "Fehler beim Aktualisieren der Einnahmen",
    loadingProfile: "Profil wird geladen...",
    loadingRiderApp: "Rider App wird geladen",
    profileNotFound: "Profil Nicht Gefunden",
    profileNotFoundDesc: "Fahrerdaten konnten nicht abgerufen werden. Bitte versuchen Sie, sich erneut anzumelden.",
    backToLogin: "Zurück zum Login",
    waitingApproval: "Warten auf Genehmigung",
    waitingApprovalDesc: "Ihr Konto wurde erstellt, muss aber von einem Administrator genehmigt werden, bevor Sie beginnen können.",
    riderId: "Fahrer-ID",
    logout: "Abmelden",
    manageAllPlatforms: "Alle Plattformen verwalten",
    recordExternalEarning: "Externen Verdienst erfassen",
    totalTodayExternal: "Gesamt Heute (Extern)",
    noExternalOrdersToday: "Keine externen Bestellungen heute aufgezeichnet.",
    note: "Hinweis",
    multiAppNote: "Aufgrund technischer Einschränkungen der Plattformen (Just Eat, Glovo usw.) können Bestellungen nicht automatisch importiert werden. Verwenden Sie diesen Hub, um schnell zwischen Apps zu wechseln und Ihre Gesamteinnahmen an einem Ort zu verfolgen.",
    locationAccessDenied: "⚠️ Standortzugriff verweigert.\n\nUm als Fahrer zu arbeiten, müssen Sie den Standortzugriff 'Immer' oder 'Beim Verwenden der App' zulassen.\n\nGehen Sie zu Einstellungen > Datenschutz > Standort.",
    locationUnavailable: "⚠️ Standort nicht verfügbar. Bitte stellen Sie sicher, dass GPS aktiviert ist.",
    locationTimeout: "⚠️ Zeitüberschreitung. Gehen Sie nach draußen und versuchen Sie es erneut.",
    callError: "Fehler beim Anruf: ",
    namePhoneRequired: "Name und Telefonnummer sind erforderlich",
    profileUpdated: "Profil erfolgreich aktualisiert!",
    profileUpdateError: "Fehler beim Aktualisieren des Profils",
    mustBeApprovedOnline: "Sie müssen genehmigt sein, um online zu gehen.",
    mustBeApprovedAccept: "Sie müssen genehmigt sein, um Bestellungen anzunehmen.",
    locationNotAvailableOnline: "Standort nicht verfügbar. Stellen Sie sicher, dass Sie online sind.",
    missingDestCoords: "Fehlende Zielkoordinaten für {address}. Navigation kann nicht gestartet werden.",
    videoCallComingSoon: "Videoanruf-Funktion kommt bald!",
    walletToday: "Brieftasche Heute",

    // Navigator
    activeNavigation: "Aktive Navigation",
    previewRoute: "Routenvorschau",
    startNavigation: "NAVIGATION STARTEN",
    nextTurn: "Nächste Abbiegung",
    destination: "Ziel",
    youAreHere: "Sie sind hier",
    missingCoordinates: "Fehlende Koordinaten",
    gpsSignalLost: "GPS-Signal Verloren",
    addressNotFound: "Adresse Nicht Gefunden",
    searchingLocation: "Standortsuche...",
    searchingLocationDesc: "Wir suchen nach den Koordinaten der Adresse.",
    cantDetectLocation: "Ihr Standort kann nicht ermittelt werden.",
    invalidDestination: "Die Zieladresse hat ungültige Koordinaten.",
    cantDetectLocationDesc: "Ihr Standort kann nicht ermittelt werden. Bitte stellen Sie sicher, dass GPS aktiviert ist.",
    addressNotFoundDesc: "Wir konnten keine Koordinaten finden für:",
    close: "Schließen",

    // Instructions
    head: "Fahren Sie Richtung",
    destinationReached: "Sie haben Ihr Ziel erreicht",

    // Route Planner
    routePlanner: "Routenplaner",
    dragToReorder: "Verwenden Sie die Pfeile, um die Haltestellen neu anzuordnen",
    startRoute: "Route Starten",
    noActiveOrders: "Keine aktiven Bestellungen zu planen",
    pickup: "Abholung",
    dropoff: "Lieferung",
    
    // Admin Dashboard
    admin_orders_history: "Bestellhistorie",
    admin_orders_history_desc: "Archivverwaltung",
    admin_delivery: "Lieferungen",
    admin_shipping: "Versand",
    admin_delivery_desc: "Zonen und Kosten",
    admin_shipping_desc: "Versandkosten",
    admin_rider_map: "Fahrerkarte",
    admin_rider_map_desc: "Flottenmanagement und Tracking",
    admin_products: "Produkte",
    admin_products_desc: "Artikel verwalten",
    admin_ingredients: "Zutaten",
    admin_variants: "Varianten",
    admin_ingredients_desc: "Extras und Ergänzungen",
    admin_variants_desc: "Größen, Farben",
    admin_menu_structure: "Menüstruktur",
    admin_menu_structure_desc: "Menüs und Kategorien",
    admin_opening_hours: "Öffnungszeiten",
    admin_opening_hours_desc: "Tage, Zeiten und Urlaub",
    admin_graphics: "Grafik & Farben",
    admin_graphics_desc: "Erscheinungsbild anpassen",
    admin_customers: "Kunden",
    admin_customers_desc: "Liste und Kontakte",
    admin_cameras: "Kameras",
    admin_cameras_desc: "IP-Kameras konfigurieren",
    admin_fiscal_printer: "Fiskaldrucker",
    admin_fiscal_printer_desc: "Kassenintegration",
    admin_advanced_settings: "Erweiterte Konfigurationen",
    admin_settings_general: "Allgemein & Zahlungen",
    admin_settings_general_desc: "Geschäftsinfo, Nexi, Satispay, PayPal, Sounds",
    admin_settings_marketing: "Marketing & Treue",
    admin_settings_marketing_desc: "Treueprogramm, Gutscheine, Serviceoptionen",
    admin_settings_system: "System & Daten",
    admin_settings_system_desc: "Backup, Sicherheit, Admin",
    
    // Marketing & Loyalty
    discount_auto: "Automatischer Kassenrabatt",
    discount_auto_desc: "Wendet einen automatischen prozentualen Rabatt auf den Warenkorbwert für bestimmte Bestellarten an. Dieser Rabatt wird direkt im Warenkorb abgezogen, ohne dass Codes erforderlich sind.",
    discount_delivery_pct: "Lieferrabatt (%)",
    discount_takeaway_pct: "Abholrabatt (%)",
    discount_dinein_pct: "Tischrabatt (%)",
    confirm_save: "Bestätigen (Speichern nicht vergessen)",

    // Header Admin
    admin_header_intercom: "Gegens.",
    admin_header_intercom_title: "Lokal Anrufen (Video)",
    admin_header_mute: "Stumm",
    admin_header_notif: "Ton",
    admin_header_mute_title: "Intercom-Anrufe auf diesem Gerät stumm",
    admin_header_unmute_title: "Intercom-Anrufe wieder aktivieren",
    admin_header_cam: "Kamera",
    admin_header_cam_title: "Kameramonitor",
    admin_header_rider: "Fahrer",
    admin_header_rider_title: "Fahrermonitor",
    admin_header_app: "App",
    admin_header_app_title: "Kunden-App anzeigen",
    admin_header_orders: "Bestellungen",
    admin_header_orders_title: "Aktuelle Bestellungen",
    admin_header_exit: "Beenden",
    admin_header_exit_title: "Admin beenden",

    // Tooltips
    iot_browser_mode_tooltip: "Dies ist für 'Android Embedded' POS-Lösungen wie Sunmi-Terminals oder klassische Tablets. Wenn eine Bestellung generiert wird, fügt der Browser sofort eine scrollbare Vorlage in ein Ghost-Fenster ein und erzwingt einen thermischen automatischen Druck beim Empfang.",
    iot_epos_mode_tooltip: "Ermöglicht die automatische Verbindung zu Ihren WLAN-Druckern und umgeht Systemfenster. Sendet direkte Eingaben über die lokale IP-URL des Druckers (z. B. 192.168.1.100), sofern dieser den FPMate/ePOS-Dienst unterstützt (wie die Epson TM-Serie).",
    iot_webhook_mode_tooltip: "Ideal für die Cloud-Automatisierung. Jedes Mal, wenn Sie eine Bestellung erhalten, führt das System eine Webhook-Anfrage (HTTP POST) an die eingegebene URL (z. B. Make, Zapier oder Ihren Server) durch und sendet die gesamte Quittung im JSON-Format.",
    analytics_timeframe_tooltip: "Der Filter ändert den Zeithorizont, auf den die analytische Intelligenz ihre Vorhersagen und Zählungen stützt (letzte 7, 30 oder 90 Tage).",
    analytics_today_prediction_tooltip: "Dies ist die probabilistische Berechnung der für heute erwarteten Bestellungen für den gesamten Tag. Sie wird durchgeführt, indem der gewichtete Durchschnitt der Anzahl der Bestellungen berechnet wird, die Sie normalerweise für den aktuellen Wochentag erhalten.",
    analytics_total_orders_tooltip: "Summe der im ausgewählten Zeitraum generierten Quittungen. Diese Zahl dient als historisches Reservoir für die prädiktive Analyse.",
    analytics_revenue_tooltip: "Gesamter über die App im analysierten Zeitraum generierter Netto-Umsatz (ohne manuelle Rückerstattungen oder Stornierungen).",
    analytics_weekly_chart_tooltip: "Balkendiagramm über den kumulativen Zufluss, verteilt auf die Wochentage. Sehr nützlich, um auf einen Blick die Spitzentage zu identifizieren, an denen zusätzliches Personal eingestellt werden muss, und die toten Tage, um Flash-Rabatte zu starten.",
    analytics_peak_hours_tooltip: "Diagramm der stündlichen Verteilung. Zeigt, zu welcher genauen Uhrzeit Kunden vorbestellen. Grundlegend für die Küche, um zu bestimmen, wann mit dem Vorheizen und dem strategischen Backen begonnen werden soll."
  },
  pt: {
    online: "ONLINE",
    offline: "OFFLINE",
    deliveries: "Entregas",
    earnings: "Ganhos",
    multiAppHub: "Hub Multi-App",
    closeWorkday: "Fechar Dia",
    confirmCloseWorkday: "Tem certeza que quer fechar o dia de trabalho? Isso resetará os contadores diários e salvará um resumo no histórico.",
    workdayClosed: "Dia fechado com sucesso!",
    errorClosingWorkday: "Erro ao fechar o dia.",
    locationError: "Geolocalização não suportada",
    confirmRejectOrder: "Tem certeza que deseja recusar este pedido?",
    confirmAcceptOrder: "Aceita este pedido?",
    enterValidAmount: "Insira um valor válido",
    errorUpdatingEarnings: "Erro ao atualizar os ganhos",
    loadingProfile: "A carregar perfil...",
    loadingRiderApp: "A carregar app Estafeta",
    profileNotFound: "Perfil não encontrado",
    profileNotFoundDesc: "Não foi possível recuperar os dados. Tente fazer login novamente.",
    backToLogin: "Voltar para Login",
    waitingApproval: "Aguardando Aprovação",
    waitingApprovalDesc: "A sua conta foi criada, mas precisa de aprovação do administrador.",
    riderId: "ID Estafeta",
    logout: "Sair",
    manageAllPlatforms: "Gerenciar Pataformas",
    recordExternalEarning: "Adicionar Ganho Externo",
    totalTodayExternal: "Total Hoje (Externo)",
    noExternalOrdersToday: "Sem pedidos externos registados hoje.",
    note: "Nota",
    multiAppNote: "Use este Hub para alternar rapidamente entre apps e acompanhar os seus ganhos totais.",
    locationAccessDenied: "⚠️ Acesso à localização negado.",
    locationUnavailable: "⚠️ Localização indisponível. Ative o GPS.",
    locationTimeout: "⚠️ Timeout. Vá para o exterior e tente novamente.",
    callError: "Erro ao ligar: ",
    namePhoneRequired: "Nome e contacto são obrigatórios",
    profileUpdated: "Perfil atualizado!",
    profileUpdateError: "Erro ao atualizar o perfil",
    mustBeApprovedOnline: "Precisa de aprovação para ficar online.",
    mustBeApprovedAccept: "Precisa de aprovação para aceitar pedidos.",
    locationNotAvailableOnline: "Localização indisponível. Fique online.",
    missingDestCoords: "Sem coordenadas. Impossível navegar.",
    videoCallComingSoon: "Vídeo-chamadas em breve!",
    walletToday: "Carteira Hoje",
    activeNavigation: "Navegação Ativa",
    previewRoute: "Pré-visualizar Rota",
    startNavigation: "INICIAR NAVEGAÇÃO",
    nextTurn: "Próxima Curva",
    destination: "Destino",
    youAreHere: "Está aqui",
    missingCoordinates: "Coordenadas em Falta",
    gpsSignalLost: "Sinal GPS Perdido",
    addressNotFound: "Morada Não Encontrada",
    searchingLocation: "A Procurar Posicionamento...",
    searchingLocationDesc: "A procurar coordenadas.",
    cantDetectLocation: "Impossível detetar localização.",
    invalidDestination: "O destino não tem coordenadas válidas.",
    cantDetectLocationDesc: "Certifique-se de que o GPS está ativo.",
    addressNotFoundDesc: "Não encontrámos coordenadas para:",
    close: "Fechar",
    head: "Siga para",
    destinationReached: "Chegou ao destino",
    routePlanner: "Gestor de Rota",
    dragToReorder: "Arraste para ordenar as paragens",
    startRoute: "Iniciar Rota",
    noActiveOrders: "Sem pedidos ativos",
    pickup: "Recolha",
    dropoff: "Entrega",
    admin_orders_history: "Histórico de Pedidos",
    admin_orders_history_desc: "Gestão do arquivo",
    admin_delivery: "Locais de Entrega",
    admin_shipping: "Envios",
    admin_delivery_desc: "Zonas e custos",
    admin_shipping_desc: "Custos de Envio",
    admin_rider_map: "Mapa dos Estafetas",
    admin_rider_map_desc: "Gestão de frota",
    admin_products: "Produtos",
    admin_products_desc: "Ver Artigos",
    admin_ingredients: "Ingredientes",
    admin_variants: "Variantes",
    admin_ingredients_desc: "Extras e suplementos",
    admin_variants_desc: "Tamanhos, Cores",
    admin_menu_structure: "Estrutura do Menu",
    admin_menu_structure_desc: "Categorias",
    admin_opening_hours: "Horários & Fechos",
    admin_opening_hours_desc: "Dias e feriados",
    admin_graphics: "Opções Gráficas",
    admin_graphics_desc: "Personalizar aspeto",
    admin_customers: "Clientes",
    admin_customers_desc: "Lista e Contactos",
    admin_cameras: "Câmaras",
    admin_cameras_desc: "Câmaras IP",
    admin_fiscal_printer: "Impressora Fiscal",
    admin_fiscal_printer_desc: "Configurar POS",
    admin_advanced_settings: "Definições Avançadas",
    admin_settings_general: "Geral e Pagamentos",
    admin_settings_general_desc: "Gateway Pagamentos",
    admin_settings_marketing: "Marketing",
    admin_settings_marketing_desc: "Fidelização e Cupões",
    admin_settings_system: "Sistema",
    admin_settings_system_desc: "Backup e Segurança",
    discount_auto: "Desconto Automático",
    discount_auto_desc: "Aplica descontos automáticos.",
    discount_delivery_pct: "Desc. Entrega (%)",
    discount_takeaway_pct: "Desc. Takeaway (%)",
    discount_dinein_pct: "Desc. Mesa (%)",
    confirm_save: "Confirmar",
    admin_header_intercom: "Intercom",
    admin_header_intercom_title: "Chamar Local",
    admin_header_mute: "Mudo",
    admin_header_notif: "Som",
    admin_header_mute_title: "Silenciar app",
    admin_header_unmute_title: "Som app",
    admin_header_cam: "Cam",
    admin_header_cam_title: "Monitor Câmaras",
    admin_header_rider: "Estafeta",
    admin_header_rider_title: "Monitor Estafetas",
    admin_header_app: "App",
    admin_header_app_title: "App Cliente",
    admin_header_orders: "Pedidos",
    admin_header_orders_title: "Pedidos Ativos",
    admin_header_exit: "Sair",
    admin_header_exit_title: "Sair",
    iot_browser_mode_tooltip: "Automático Browser",
    iot_epos_mode_tooltip: "Modo Epson POS",
    iot_webhook_mode_tooltip: "Webhook API",
    analytics_timeframe_tooltip: "Janela analítica",
    analytics_today_prediction_tooltip: "Estimativa de hoje",
    analytics_total_orders_tooltip: "Total acumulativo",
    analytics_revenue_tooltip: "Rentabilidade bruta",
    analytics_weekly_chart_tooltip: "Afinamento de picos",
    analytics_peak_hours_tooltip: "Horas de ponta"
  },
  ru: {
    online: "В СЕТИ",
    offline: "НЕ В СЕТИ",
    deliveries: "Доставки",
    earnings: "Заработок",
    multiAppHub: "Мульти-Хаб",
    closeWorkday: "Завершить день",
    confirmCloseWorkday: "Уверены, что хотите завершить день? Счетчики будут сброшены.",
    workdayClosed: "Рабочий день успешно завершен!",
    errorClosingWorkday: "Ошибка при завершении дня.",
    locationError: "Локация не поддерживается",
    confirmRejectOrder: "Отклонить заказ?",
    confirmAcceptOrder: "Принять заказ?",
    enterValidAmount: "Введите сумму",
    errorUpdatingEarnings: "Ошибка обновления заработка",
    loadingProfile: "Загрузка профиля...",
    loadingRiderApp: "Загрузка курьера",
    profileNotFound: "Профиль не найден",
    profileNotFoundDesc: "Попробуйте войти снова.",
    backToLogin: "Вернуться к логину",
    waitingApproval: "Ожидание проверки",
    waitingApprovalDesc: "Ваш аккаунт требует подтверждения.",
    riderId: "ID курьера",
    logout: "Выйти",
    manageAllPlatforms: "Управлять платформами",
    recordExternalEarning: "Добавить сторонний заработок",
    totalTodayExternal: "Итого (Внешние)",
    noExternalOrdersToday: "Нет внешних заказов.",
    note: "Справка",
    multiAppNote: "Следите за всеми заказами с разных платформ здесь.",
    locationAccessDenied: "⚠️ Доступ к локации запрещен.",
    locationUnavailable: "⚠️ Локация недоступна.",
    locationTimeout: "⚠️ Тайм-аут поиска GPS.",
    callError: "Ошибка звонка: ",
    namePhoneRequired: "Имя и телефон обязательны",
    profileUpdated: "Успешно!",
    profileUpdateError: "Ошибка сохранения",
    mustBeApprovedOnline: "Нужен апрув для выхода в сеть.",
    mustBeApprovedAccept: "Нужен апрув для работы.",
    locationNotAvailableOnline: "Сначала включите геолокацию.",
    missingDestCoords: "Нет координат цели.",
    videoCallComingSoon: "Скоро!",
    walletToday: "Заработано",
    activeNavigation: "Навигация",
    previewRoute: "Маршрут",
    startNavigation: "НАЧАТЬ ПУТЬ",
    nextTurn: "След. поворот",
    destination: "Точка",
    youAreHere: "Вы здесь",
    missingCoordinates: "Ожидание GPS",
    gpsSignalLost: "Нет сигнала GPS",
    addressNotFound: "Адрес не распознан",
    searchingLocation: "Ищем спутники...",
    searchingLocationDesc: "Получаем координаты.",
    cantDetectLocation: "Не можем вас найти.",
    invalidDestination: "Плохие координаты цели.",
    cantDetectLocationDesc: "Проверьте включен ли GPS датчик.",
    addressNotFoundDesc: "Где это находится?:",
    close: "Закрыть",
    head: "Направляйтесь на",
    destinationReached: "Вы на месте",
    routePlanner: "Планировщик",
    dragToReorder: "Тяните для сортировки",
    startRoute: "Поехали",
    noActiveOrders: "Нет активных заказов",
    pickup: "Забрать",
    dropoff: "Доставить",
    admin_orders_history: "История заказов",
    admin_orders_history_desc: "Архив",
    admin_delivery: "Зоны доставки",
    admin_shipping: "Доставка почтой",
    admin_delivery_desc: "Зоны и цены",
    admin_shipping_desc: "Цена доставки",
    admin_rider_map: "Карта курьеров",
    admin_rider_map_desc: "Геолокация в реальном времени",
    admin_products: "Товары",
    admin_products_desc: "Управление меню",
    admin_ingredients: "Ингредиенты",
    admin_variants: "Вариации",
    admin_ingredients_desc: "Добавки",
    admin_variants_desc: "Размеры, типы",
    admin_menu_structure: "Структура меню",
    admin_menu_structure_desc: "Категории",
    admin_opening_hours: "График работы",
    admin_opening_hours_desc: "Часы и выходные",
    admin_graphics: "Дизайн",
    admin_graphics_desc: "Цвета и логотипы",
    admin_customers: "Клиенты",
    admin_customers_desc: "База",
    admin_cameras: "Камеры",
    admin_cameras_desc: "IP Камеры видеонаблюдения",
    admin_fiscal_printer: "Кассовые аппараты",
    admin_fiscal_printer_desc: "Настройка чеков",
    admin_advanced_settings: "Доп. настройки",
    admin_settings_general: "Основные и Оплата",
    admin_settings_general_desc: "Включая платежные системы",
    admin_settings_marketing: "Лояльность",
    admin_settings_marketing_desc: "Акции и скидки",
    admin_settings_system: "Система",
    admin_settings_system_desc: "Бекапы",
    discount_auto: "Авто скидка",
    discount_auto_desc: "Автоматическое применение скидок.",
    discount_delivery_pct: "Скидка (доставка) %",
    discount_takeaway_pct: "Скидка (навынос) %",
    discount_dinein_pct: "Скидка (в заведении) %",
    confirm_save: "Сохранить везде",
    admin_header_intercom: "Интерком",
    admin_header_intercom_title: "Вызов персонала",
    admin_header_mute: "Тихо",
    admin_header_notif: "Звук",
    admin_header_mute_title: "Без звука",
    admin_header_unmute_title: "Включить звук",
    admin_header_cam: "Камеры",
    admin_header_cam_title: "Наблюдение",
    admin_header_rider: "Курьеры",
    admin_header_rider_title: "Монитор",
    admin_header_app: "Приложение",
    admin_header_app_title: "Мобильная версия",
    admin_header_orders: "Заказы",
    admin_header_orders_title: "Очередь",
    admin_header_exit: "Выход",
    admin_header_exit_title: "Выход из админки",
    iot_browser_mode_tooltip: "Терминал POS",
    iot_epos_mode_tooltip: "Прямая печать Wi-Fi (Epson)",
    iot_webhook_mode_tooltip: "Webhooks (API)",
    analytics_timeframe_tooltip: "Период",
    analytics_today_prediction_tooltip: "Прогноз на день",
    analytics_total_orders_tooltip: "Всего чеков",
    analytics_revenue_tooltip: "Общий доход",
    analytics_weekly_chart_tooltip: "Анализ недели",
    analytics_peak_hours_tooltip: "Часы пик"
  },
  nl: {
    online: "ONLINE",
    offline: "OFFLINE",
    deliveries: "Bezorgingen",
    earnings: "Inkomsten",
    multiAppHub: "Multi-App Hub",
    closeWorkday: "Dag Sluiten",
    confirmCloseWorkday: "Weet u zeker dat u uw werkdag wilt sluiten?",
    workdayClosed: "Werkdag succesvol gesloten!",
    errorClosingWorkday: "Fout bij sluiten werkdag.",
    locationError: "Locatie niet ondersteund",
    confirmRejectOrder: "Weet u zeker dat u deze wilt weigeren?",
    confirmAcceptOrder: "Accepteert u de bestelling?",
    enterValidAmount: "Geldig bedrag invoeren",
    errorUpdatingEarnings: "Fout bij opslaan",
    loadingProfile: "Profiel laden...",
    loadingRiderApp: "Rider app laden",
    profileNotFound: "Profiel Niet Gevonden",
    profileNotFoundDesc: "Probeer opnieuw in te loggen.",
    backToLogin: "Terug naar Login",
    waitingApproval: "Wachten Op Goedkeuring",
    waitingApprovalDesc: "Account wordt geverifieerd door beheerder.",
    riderId: "Rider ID",
    logout: "Uitloggen",
    manageAllPlatforms: "Beheer platforms",
    recordExternalEarning: "Externe Rit",
    totalTodayExternal: "Totaal Externe Ritten",
    noExternalOrdersToday: "Geen ritten geregistreerd vandaag.",
    note: "Notitie",
    multiAppNote: "Overzicht voor externe ritten en apps.",
    locationAccessDenied: "⚠️ Geen locatie toegang.",
    locationUnavailable: "⚠️ Locatie niet beschikbaar. GPS controleren.",
    locationTimeout: "⚠️ GPS Timeout.",
    callError: "Oproep fout: ",
    namePhoneRequired: "Gegevens ontbreken",
    profileUpdated: "Profiel bijgewerkt!",
    profileUpdateError: "Profiel opslaan mislukt",
    mustBeApprovedOnline: "Goedkeuring vereist om online te gaan.",
    mustBeApprovedAccept: "Goedkeuring vereist om te werken.",
    locationNotAvailableOnline: "GPS niet beschikbaar. Activeer locatie.",
    missingDestCoords: "Kan niet navigeren.",
    videoCallComingSoon: "Binnenkort!",
    walletToday: "Rit Inkomsten",
    activeNavigation: "Navigatie Aan",
    previewRoute: "Bekijk Route",
    startNavigation: "START REIS",
    nextTurn: "Volgende Afslag",
    destination: "Bestemming",
    youAreHere: "U bent hier",
    missingCoordinates: "Coördinaten Ontbreken",
    gpsSignalLost: "GPS Signaal Weg",
    addressNotFound: "Adres Niet Gevonden",
    searchingLocation: "Zoeken naar locatie...",
    searchingLocationDesc: "Coördinaten ophalen.",
    cantDetectLocation: "Locatie onbekend.",
    invalidDestination: "Onjuist bestemmingsadres.",
    cantDetectLocationDesc: "Controleer of GPS geactiveerd is.",
    addressNotFoundDesc: "Niet gevonden:",
    close: "Sluiten",
    head: "Ga naar",
    destinationReached: "U bent er",
    routePlanner: "Routeplanner",
    dragToReorder: "Sleep om volgorde te verplaatsen",
    startRoute: "Start Rit",
    noActiveOrders: "Geen actieve opdrachten",
    pickup: "Ophalen bij winkel",
    dropoff: "Afleveren bij klant",
    admin_orders_history: "Kassa Archief",
    admin_orders_history_desc: "Bonnen en historie",
    admin_delivery: "Bezorgingzones",
    admin_shipping: "Verzendingen",
    admin_delivery_desc: "Straten en kosten",
    admin_shipping_desc: "Verzendkosten",
    admin_rider_map: "Bezorgers Kaart",
    admin_rider_map_desc: "Live locaties",
    admin_products: "Producten",
    admin_products_desc: "Artikelen beheren",
    admin_ingredients: "Ingrediënten",
    admin_variants: "Varianten",
    admin_ingredients_desc: "Opties",
    admin_variants_desc: "Maten etc.",
    admin_menu_structure: "Menu Structuur",
    admin_menu_structure_desc: "Categorieën",
    admin_opening_hours: "Openingstijden",
    admin_opening_hours_desc: "Gesloten en pauzes",
    admin_graphics: "Vormgeving",
    admin_graphics_desc: "Kleuren",
    admin_customers: "Bestande Klanten",
    admin_customers_desc: "Lijst",
    admin_cameras: "Camera's",
    admin_cameras_desc: "CCTV/IP Cams",
    admin_fiscal_printer: "Thermische Printer",
    admin_fiscal_printer_desc: "Klantbon",
    admin_advanced_settings: "Instellingen",
    admin_settings_general: "Algemeen/Betaal",
    admin_settings_general_desc: "Tikkie/iDeal/Pin",
    admin_settings_marketing: "Kortingen",
    admin_settings_marketing_desc: "Zegels & coupons",
    admin_settings_system: "Systeem",
    admin_settings_system_desc: "Beveiliging",
    discount_auto: "Automatisch Korting",
    discount_auto_desc: "Regels instellen.",
    discount_delivery_pct: "Bezorg Korting %",
    discount_takeaway_pct: "Afhaal Korting %",
    discount_dinein_pct: "Eten in Korting %",
    confirm_save: "Opslaan",
    admin_header_intercom: "Contact",
    admin_header_intercom_title: "Videobel locatie",
    admin_header_mute: "Stil",
    admin_header_notif: "Aan",
    admin_header_mute_title: "Dempen",
    admin_header_unmute_title: "Volumeknop",
    admin_header_cam: "Camera",
    admin_header_cam_title: "Zien",
    admin_header_rider: "Riders",
    admin_header_rider_title: "Logistiek",
    admin_header_app: "App",
    admin_header_app_title: "App Testen",
    admin_header_orders: "Keuken",
    admin_header_orders_title: "Bonnen",
    admin_header_exit: "Terug",
    admin_header_exit_title: "Sluiten",
    iot_browser_mode_tooltip: "Print POS Android.",
    iot_epos_mode_tooltip: "Print ePOS ESC/POS.",
    iot_webhook_mode_tooltip: "Webhooks doorgeven.",
    analytics_timeframe_tooltip: "Filter dagen.",
    analytics_today_prediction_tooltip: "Drukte voorspeller.",
    analytics_total_orders_tooltip: "Som bonnen.",
    analytics_revenue_tooltip: "Geld lade.",
    analytics_weekly_chart_tooltip: "Drukke dagen.",
    analytics_peak_hours_tooltip: "Gezellige uurtjes."
  },
  cz: {
    online: "ONLINE",
    offline: "OFFLINE",
    deliveries: "Doručení",
    earnings: "Vyděláno",
    multiAppHub: "Externí platformy",
    closeWorkday: "Konec směny",
    confirmCloseWorkday: "Jste si jisti? Resetují se data.",
    workdayClosed: "Směna úspěšně ukončena!",
    errorClosingWorkday: "Chyba.",
    locationError: "Lokace nepodporována",
    confirmRejectOrder: "Odmítnout?",
    confirmAcceptOrder: "Příjmout?",
    enterValidAmount: "Zadejte částku",
    errorUpdatingEarnings: "Chyba uložení",
    loadingProfile: "Profil...",
    loadingRiderApp: "Načítám...",
    profileNotFound: "Profil nenalezen",
    profileNotFoundDesc: "Přihlaste se znovu.",
    backToLogin: "Zpět na přihlášení",
    waitingApproval: "Čeká se na schválení",
    waitingApprovalDesc: "Na schválení u administrátora.",
    riderId: "ID kurýra",
    logout: "Odhlásit",
    manageAllPlatforms: "Hub pro 3. strany",
    recordExternalEarning: "Nový výdělek - Wolt/Foodora",
    totalTodayExternal: "Dnes: třetí strany",
    noExternalOrdersToday: "Zatím žádné...",
    note: "Info",
    multiAppNote: "Sledujte vaše mzdy napříč aplikacemi.",
    locationAccessDenied: "⚠️ Povolte GPS.",
    locationUnavailable: "⚠️ GPS nedostupná.",
    locationTimeout: "⚠️ GPS vypršela.",
    callError: "Chyba hovoru: ",
    namePhoneRequired: "Nutno vyplnit",
    profileUpdated: "Uloženo!",
    profileUpdateError: "Chyba uložení profilu",
    mustBeApprovedOnline: "Nejste schválení pro online provoz.",
    mustBeApprovedAccept: "Schválení nutné pro doručování.",
    locationNotAvailableOnline: "Povolte GPS první.",
    missingDestCoords: "Cíl nemá GPS souřadnice.",
    videoCallComingSoon: "Již brzy!",
    walletToday: "Pěněženka",
    activeNavigation: "Aktivní trasa",
    previewRoute: "Náhled",
    startNavigation: "NAVIGOVAT",
    nextTurn: "Další odbočka",
    destination: "Cíl",
    youAreHere: "Jste zde",
    missingCoordinates: "Chybí GPS data",
    gpsSignalLost: "Ztráta signálu GPS",
    addressNotFound: "Adresa nelze vyhledat",
    searchingLocation: "Geokódování...",
    searchingLocationDesc: "Měníme adresu na body.",
    cantDetectLocation: "Neukazuje se nám vaše pozice.",
    invalidDestination: "Chybná destinace cílového adresáta.",
    cantDetectLocationDesc: "Je prosím GPS aktivní?",
    addressNotFoundDesc: "Nic nenalezeno za adresou:",
    close: "Zavřít",
    head: "Běžte po",
    destinationReached: "Dosáhli jste cíle",
    routePlanner: "Plánovač tras",
    dragToReorder: "Posuňte a zamíchejte",
    startRoute: "Start",
    noActiveOrders: "Žádné zakázky",
    pickup: "Vzít s sebou",
    dropoff: "Dát zákazníkovi",
    admin_orders_history: "Historie Objednávek",
    admin_orders_history_desc: "Archiv",
    admin_delivery: "Dělení Zón",
    admin_shipping: "Zásilková Služba",
    admin_delivery_desc: "Lokace",
    admin_shipping_desc: "Logistika",
    admin_rider_map: "Poloha Kurýrů",
    admin_rider_map_desc: "Fleet GPS Tracking",
    admin_products: "Produkty",
    admin_products_desc: "Ceny & Jména",
    admin_ingredients: "Přísady",
    admin_variants: "Typy Jídel",
    admin_ingredients_desc: "Placeně/Zdarma",
    admin_variants_desc: "Barevné / Velikosti",
    admin_menu_structure: "Kategorie",
    admin_menu_structure_desc: "Složky MENU",
    admin_opening_hours: "Svátky, Měna a Časovač",
    admin_opening_hours_desc: "Konfigurace Otevření",
    admin_graphics: "Barevná Párty.cz",
    admin_graphics_desc: "Vaše barvy",
    admin_customers: "Báze",
    admin_customers_desc: "Vaši strávnici",
    admin_cameras: "Bezpečnost",
    admin_cameras_desc: "Kamery",
    admin_fiscal_printer: "Tiskárna",
    admin_fiscal_printer_desc: "ESC Pos Tiskárny...",
    admin_advanced_settings: "Admin Setup",
    admin_settings_general: "Platební brány a.i.",
    admin_settings_general_desc: "Karty atd.",
    admin_settings_marketing: "Marketing",
    admin_settings_marketing_desc: "Kupóny věrnosti",
    admin_settings_system: "Jádro Appky",
    admin_settings_system_desc: "Oprávnění",
    discount_auto: "Auto sleva",
    discount_auto_desc: "Vždy...",
    discount_delivery_pct: "Pro RIDER (Doručení)",
    discount_takeaway_pct: "S Sebou",
    discount_dinein_pct: "Pro Saloon",
    confirm_save: "Ok potvrdit do DB",
    admin_header_intercom: "Interkom",
    admin_header_intercom_title: "Videohovor",
    admin_header_mute: "Ticho",
    admin_header_notif: "Cvrkot",
    admin_header_mute_title: "Bez vyzvánění",
    admin_header_unmute_title: "Akorát zvuk na app.",
    admin_header_cam: "Pohled",
    admin_header_cam_title: "Zabezpečen",
    admin_header_rider: "Rider APP",
    admin_header_rider_title: "Flotila",
    admin_header_app: "App",
    admin_header_app_title: "Simulace apky",
    admin_header_orders: "Kuchyň",
    admin_header_orders_title: "Řídit objednávku",
    admin_header_exit: "Konec",
    admin_header_exit_title: "Logout pro šéfa",
    iot_browser_mode_tooltip: "To se hodí jestli...",
    iot_epos_mode_tooltip: "IP adresy wifi print",
    iot_webhook_mode_tooltip: "Poslat JSON dál pryč",
    analytics_timeframe_tooltip: "Na filtry časovačů.",
    analytics_today_prediction_tooltip: "Algoritmus ti tu radí.",
    analytics_total_orders_tooltip: "Prostě počet ks stvrzenek.",
    analytics_revenue_tooltip: "Tržba a vejplaty.",
    analytics_weekly_chart_tooltip: "Tloušťka objednávek za time.",
    analytics_peak_hours_tooltip: "Hlavně časy návalu pro pec."
  },
  hr: {
    online: "NA MREŽI",
    offline: "ODJAVLJEN",
    deliveries: "Dostave",
    earnings: "Zarada",
    multiAppHub: "Sve Platforme",
    closeWorkday: "Zatvori Smjenu",
    confirmCloseWorkday: "Jeste li sigurni? Sustav se resetira danas.",
    workdayClosed: "Dnevnik rada uspješno zatvoren!",
    errorClosingWorkday: "Pogreška prilikom gašenja.",
    locationError: "Lokacija nema dozvolu.",
    confirmRejectOrder: "Odbijaš prijem naloga?",
    confirmAcceptOrder: "Prihvaćaš tranzit?",
    enterValidAmount: "Unesi dobar iznos eur",
    errorUpdatingEarnings: "Spremi error.",
    loadingProfile: "Profil iz baze...",
    loadingRiderApp: "Startaš dostavljača...",
    profileNotFound: "Nismo pronašli osobu",
    profileNotFoundDesc: "Krivi profil.",
    backToLogin: "Povratak na Prijavu",
    waitingApproval: "Na čekanju dozvola bosa",
    waitingApprovalDesc: "Netko mora kliknuti 'Da' za tvoj login u adminu.",
    riderId: "Broj Djelatnika",
    logout: "Odjavi me.",
    manageAllPlatforms: "Hub dostava od drugih",
    recordExternalEarning: "Unesi gotovinu trećih",
    totalTodayExternal: "Danas - Strani Posao",
    noExternalOrdersToday: "Pusto na radarima.",
    note: "Obavijest",
    multiAppNote: "Glovo/Wolt itd ne daju sync.",
    locationAccessDenied: "⚠️ GPS Off lokacija blok",
    locationUnavailable: "⚠️ Satelit signal loš.",
    locationTimeout: "⚠️ GPS je spavao.",
    callError: "Bug poziv: ",
    namePhoneRequired: "Unesite broj",
    profileUpdated: "Podešavanja riješena",
    profileUpdateError: "Server te odbio",
    mustBeApprovedOnline: "Moraš bit primljen na posao.",
    mustBeApprovedAccept: "Samo licencirani kurir prima.",
    locationNotAvailableOnline: "Samo kad je GPS dobar.",
    missingDestCoords: "Nema destinacije zemljopis.",
    videoCallComingSoon: "Još se razvija!",
    walletToday: "Blagajna tvoja",
    activeNavigation: "Put u Tijeku",
    previewRoute: "Crtanje Mape",
    startNavigation: "PALI SVE",
    nextTurn: "Tvoje okretište iduće",
    destination: "Ciljna točka P",
    youAreHere: "Evo ti si ovdje plavo",
    missingCoordinates: "Satelit problem. Adresa mrtva",
    gpsSignalLost: "Signala Niđe",
    addressNotFound: "Kartografija zbunjena adresa fali",
    searchingLocation: "Geolokacija traži...",
    searchingLocationDesc: "U procesu analize teksta s ulice na x i y osovinu.",
    cantDetectLocation: "Ne znam gdje tvoj mob stoji.",
    invalidDestination: "Nemoguće rutirati",
    cantDetectLocationDesc: "Otvori prozor, oblak puca satelit.",
    addressNotFoundDesc: "Svašta našlo nije ali:",
    close: "Gasi",
    head: "Pješi vozi do",
    destinationReached: "Ti si na cilj",
    routePlanner: "Kalkulator Trasa",
    dragToReorder: "Uzmi ručkicu i miš - vuci",
    startRoute: "Idem ja",
    noActiveOrders: "Slobodan si tren.",
    pickup: "Paket na Bazu",
    dropoff: "Bacan klijentu na adr.",
    admin_orders_history: "Ahriva Kas",
    admin_orders_history_desc: "Papiri idu ode",
    admin_delivery: "Zona Granice Dostave",
    admin_shipping: "Kurirske Službe",
    admin_delivery_desc: "Zoniranje KM / Iznos",
    admin_shipping_desc: "Paketne usluge i poštarina",
    admin_rider_map: "Radari GPS Motora",
    admin_rider_map_desc: "Gle kamo letu",
    admin_products: "Artiklima Katalog",
    admin_products_desc: "Cijene kuc",
    admin_ingredients: "Sastav jela",
    admin_variants: "Slojevi Meni",
    admin_ingredients_desc: "Kuhinjski materijali",
    admin_variants_desc: "Alergeni/Dodaci",
    admin_menu_structure: "Kategorizacija Web",
    admin_menu_structure_desc: "Padajuće Ladice",
    admin_opening_hours: "Kad Radi Peć ?",
    admin_opening_hours_desc: "Udalji se na praznike",
    admin_graphics: "Igra Bojama CSS",
    admin_graphics_desc: "Tematika tvog fensi app-a.",
    admin_customers: "Igrači na App",
    admin_customers_desc: "Kontakti svi",
    admin_cameras: "Cyber Oči",
    admin_cameras_desc: "Streme na link u H264",
    admin_fiscal_printer: "Blagajna Fiskal?",
    admin_fiscal_printer_desc: "Ode ide kuka u IP POS",
    admin_advanced_settings: "Zadnje Tajne Konfiga",
    admin_settings_general: "Banka Kartice Info",
    admin_settings_general_desc: "API Stripe i Ekipa",
    admin_settings_marketing: "Promo Zvjer",
    admin_settings_marketing_desc: "Poeni kodovi gratis ručkovi",
    admin_settings_system: "Inženjerije",
    admin_settings_system_desc: "Briši sve ne radi",
    discount_auto: "Kupon Auto Pop",
    discount_auto_desc: "Brza fukcija od - % na dno računa.",
    discount_delivery_pct: "Riders Pop",
    discount_takeaway_pct: "Šalter Sam Dođe Popus",
    discount_dinein_pct: "Stol VIP Sjedenje P",
    confirm_save: "Pečat i Spremi Podatak",
    admin_header_intercom: "Alo",
    admin_header_intercom_title: "Dižeš Zvono u Bar?",
    admin_header_mute: "Zvuk Off",
    admin_header_notif: "Laj",
    admin_header_mute_title: "Mobitel muti zvonjave.",
    admin_header_unmute_title: "Probudi sirenu restoranu.",
    admin_header_cam: "Plafon Cam",
    admin_header_cam_title: "Daleka inspekcija pogona.",
    admin_header_rider: "Fleet App",
    admin_header_rider_title: "Uvid u sve kotače asfalta",
    admin_header_app: "App",
    admin_header_app_title: "Probaj Kao Ljudi Što Će Imat",
    admin_header_orders: "Pecanje",
    admin_header_orders_title: "Zakačeni Nalozi",
    admin_header_exit: "Doviđenja",
    admin_header_exit_title: "Pusti i gasi dashboard",
    iot_browser_mode_tooltip: "Pritne na nevidljivo ako je Android tablet star na Sunmi sustavima pos-a.",
    iot_epos_mode_tooltip: "Žiži žica - pazi samo da printer EPSON i ePOS znaju url.",
    iot_webhook_mode_tooltip: "Cloud letka API na Zapier platform.",
    analytics_timeframe_tooltip: "Razdoblje ti filtrira",
    analytics_today_prediction_tooltip: "Nagađanje šta te stiti za sat do kraja šihte po starom algoritmu..",
    analytics_total_orders_tooltip: "Količina kartica s iznosom unutar",
    analytics_revenue_tooltip: "Blago pare",
    analytics_weekly_chart_tooltip: "Pregled snage prodaje",
    analytics_peak_hours_tooltip: "Najgore opterećenje na blagajnu u 24h rasponu."
  }
};

export const getTranslation = (lang: Language, key: keyof typeof translations['it']) => {
  return translations[lang][key] || translations['it'][key];
};
